const BaseDate = ({ date }) => (
  <div className="base-date">기준일시 {date || ''}</div>
);

export default BaseDate;
